<template>
	<div class="container-box">
		<spider-window-time :time="time" v-if="time" />
		<!-- 普通信息 -->
		<div class="my-message" v-for="(item, index) in messageAll" :key="item.messageId || index">
			<!-- 通知的信息 -->
			<div v-if="item.messageType == 'ST:GrpNtf'" class="notice-message">
				{{ item.content.message }}
			</div>
			<!-- 收到的信息 -->
		<div class="friend-message" v-else-if="item.messageDirection != 1">
				<img :src="item.avatar" v-if="item.avatar" class="avatarImg" />
				<img src="@/assets/images/logo@3x.png" v-else class="avatarImg" />
				<template>
					<!-- <template v-if="item.messageType != 'RC:GroupInviteMsg'"> -->
					<div class="chat-content" :class="item.messageType == 'RC:ImgMsg' ? 'img-content' : ''">

						<!-- 信息为文本格式 -->
						<span v-if="item.messageType == 'RC:TxtMsg'">
							{{ item.content.content }}
						</span>
						<!-- 系统通知消息（蜘信支付等，文本在content.content） -->
						<span v-if="item.messageType == 'RC:SRSMsg'">
							{{ item.content.content }}
						</span>
						<!-- 通知类消息（如蜘信支付系统通知） -->
						<span v-if="item.messageType == 'RC:InfoNtf'">
							{{ item.content.message }}
						</span>
						<!-- 信息为图片格式 -->
						<img v-if="item.messageType == 'RC:ImgMsg'" :src="item.content.imageUri" alt="图片"
							@load="handleImageLoad($event, item)" class="msgImg"
							draggable="true" 
							@dragstart="handleDragStart($event, item.content.imageUri)"
							@click="handleImageClick(item.content.imageUri)"/>
						<!-- <img v-if="item.messageType == 'RC:ImgMsg'" :src="item.content.imageUri" alt="图片" class="msgImg" /> -->
						<img v-if="item.messageType == 'RC:GiftMsg'" :src="item.content.giftIconUrl"
							:alt="item.content.giftName" class="msgImg" />
						
						<!-- 红包消息 -->
						<div
							v-if="item.messageType == 'RC:TransferMsg' || item.messageType == 'redBagExpire'|| item.messageType == 'receiveRedPack' || item.messageType == 'RC:HeXiRedPackMsg'">
							不支持红包消息</div>

						<!-- 动图表情包 -->
						<img v-if="item.messageType == 'RC:StkImgMsg'" :src="item.content.packageUrl" class="msgImg" />
						<span v-if="item.messageType == 'RC:CardMsg'">
							{{ item.content.is_CardType == 0 ? '不支持名片消息' : '不支持卡片消息' }}
						</span>
						<span v-if="item.messageType == 'RC:InvitationMsg'">不支持邀请函消息</span>

						<span v-if="item.messageType == 'RC:GroupInviteMsg'">{{item.senderUser}}邀请您参加{{ item.content.name }}</span>

						<span v-if="item.messageType == 'RC:RecordSpeechMsg'">不支持录音讲话消息</span>
						<span v-if="item.messageType == 'RC:VideoSpeechMsg'">不支持视频讲话消息</span>
						<span v-if="item.messageType == 'RC:SpiderDramaMsg'">不支持蜘影剧消息</span>
						<span v-if="item.messageType == 'RC:SpiderNewsMsg'">不支持蜘影新闻消息</span>
						<span v-if="item.messageType == 'RC:SpiderShadowMsg'">不支持蜘影消息</span>
						<span v-if="item.messageType == 'RC:SCCardMsg'">
							{{ item.content.is_CardType == 0 ? '不支持名片消息' : '不支持卡片消息' }}
						</span>
						<span v-if="item.messageType == 'RC:CombineMsg'">不支持转发消息</span>
						<!-- 视频消息 -->
						<spider-window-video v-if="item.messageType == 'RC:SightMsg'" :content="item.content" />
						<span v-if="item.messageType == 'RC:RcCmd'">不支持消息</span>
						<span v-if="item.messageType == 'RC:VcMsg'">不支持语音消息</span>
						<span v-if="item.messageType == 'RC:HQVCMsg'">不支持语音消息</span>
						<span v-if="item.messageType == 'RC:LBSMsg'">不支持位置消息</span>
						<!-- 文件消息：优先匹配RC:FileMsg类型，兜底匹配含fileUrl的消息 -->
						<spider-window-file v-if="item.messageType == 'RC:FileMsg'" :content="item.content" />
						<!-- 文件格式兜底：当messageType未被识别但有fileUrl时，也渲染为文件消息 -->
						<spider-window-file v-if="item.messageType != 'RC:FileMsg' && item.content && item.content.fileUrl && !item.content.duration && item.messageType !='RC:ImgMsg' && item.messageType !='RC:StkImgMsg' && item.messageType !='RC:ArticleMsg'"
							:content="item.content" />
						<!-- 文章格式 -->
						<div v-if="item.messageType == 'RC:ArticleMsg'" class="message-circle-box"
							@click="lookArticleDetail(item)">
							<img :src="item.content.imgUrl" alt="" class="message-circle-box-img" />
							<div class="article-title">{{ item.content.title }}</div>
						</div>
						<!-- 音频格式 -->
						<!-- <audio
						:src="item.content.fileUrl"
						width="300px"
						height="200px"
						controls
						v-if="item.content.fileUrl && item.content.duration"
						/>
						<audio
						:src="item.content.remoteUrl"
						width="300px"
						height="200px"
						controls
						v-if="item.content.remoteUrl && item.content.duration"
						/> -->
						<!-- 位置地图格式 -->
						<!-- <div v-if="item.content.latitude">
						<el-amap
							:center="
							centerMarket(item.content.latitude, item.content.longitude)
							"
							:zoom="zoom"
							:vid="'container' + index"
							:id="'container' + index"
							class="map-container"
						>
							<el-amap-marker
							:position="
								centerMarket(item.content.latitude, item.content.longitude)
							"
							:label="{ content: item.content.poi, offset: [10, 12] }"
							></el-amap-marker>
						</el-amap>
						</div> -->
						<!-- 蜘信卡片格式 -->
						<!-- <div class="spider-message-box-all" v-if="item.content.userId">
						<div class="spider-message-box">
							<img
							:src="item.content.avatar"
							alt=""
							class="spider-message-img"
							/>
							<div>
							<div class="article-title">{{ item.content.name }}</div>
							</div>
						</div>
						<div class="spider-message-text">蜘信卡片</div>
						</div> -->
						<!-- 文件格式 -->
					<spider-window-file v-if="item.content.fileUrl && !item.content.duration && item.messageType !='RC:RecordSpeechMsg' && item.messageType != 'RC:FileMsg'"
						:content="item.content" />
					<!-- 未知消息类型兜底：尝试提取文本内容 -->
					<span v-if="!isKnownMessageType(item)" style="color: #999;">{{ extractFallbackText(item) || '[不支持此类型消息]' }}</span>
				</div>
			</template>
		</div>
		<!-- 发送的信息 -->
			<div class="my-chat-info" v-else-if="item.messageDirection == 1">
				<!-- <template v-if="item.messageType != 'RC:GroupInviteMsg'"> -->
				<template>
					<div class="my-chat" :class="item.messageType == 'RC:ImgMsg' ? 'img-content' : ''">
						<!-- 通知的信息 -->
						<div v-if="item.messageType == 'ST:GrpNtf'" class="notice-message">
							{{ item.content.message }}
						</div>
						<span v-if="item.messageType == 'RC:TxtMsg'">
							{{ item.content.content }}
						</span>
						<!-- 系统通知消息（蜘信支付等，文本在content.content） -->
						<span v-if="item.messageType == 'RC:SRSMsg'">
							{{ item.content.content }}
						</span>
						<!-- 通知类消息（如蜘信支付系统通知） -->
						<span v-if="item.messageType == 'RC:InfoNtf'">
							{{ item.content.message }}
						</span>
						<img v-if="item.messageType == 'RC:ImgMsg'" :src="item.content.imageUri" alt="图片"
							class="msgImg" @load="handleImageLoad($event, item)" 
							draggable="true" 
							@dragstart="handleDragStart($event, item.content.imageUri)"
							@click="handleImageClick(item.content.imageUri)"/>
						<img v-if="item.messageType == 'RC:GiftMsg'" :src="item.content.giftIconUrl"
							:alt="item.content.giftName" class="msgImg" />
						<!-- 红包消息 -->
						<div
							v-if="item.messageType == 'RC:TransferMsg' || item.messageType == 'redBagExpire' ||item.messageType == 'receiveRedPack' || item.messageType == 'RC:HeXiRedPackMsg'">
							不支持红包消息</div>
						<!-- <div v-if="item.messageType == 'redBagExpire'" >红包消息已过期</div> -->

						<!-- 表情 -->
						<img v-if="item.messageType == 'RC:StkImgMsg'" :src="item.content.packageUrl" class="msgImg" />
						<span v-if="item.messageType == 'RC:CardMsg'">
							{{ item.content.is_CardType == 0 ? '不支持名片消息' : '不支持卡片消息' }}
						</span>
						<span v-if="item.messageType == 'RC:InvitationMsg'">不支持邀请函消息</span>
						<span v-if="item.messageType == 'RC:GroupInviteMsg'">你邀请{{item.senderUser}}参加{{ item.content.name }}</span>
						<span v-if="item.messageType == 'RC:RecordSpeechMsg'">不支持录音讲话消息</span>
						<span v-if="item.messageType == 'RC:VideoSpeechMsg'">不支持视频讲话消息</span>
						<span v-if="item.messageType == 'RC:SpiderDramaMsg'">不支持蜘影剧消息</span>
						<span v-if="item.messageType == 'RC:SpiderNewsMsg'">不支持蜘影新闻消息</span>
						<span v-if="item.messageType == 'RC:SpiderShadowMsg'">不支持蜘影消息</span>
						<span v-if="item.messageType == 'RC:SCCardMsg'">
							{{ item.content.is_CardType == 0 ? '不支持名片消息' : '不支持卡片消息' }}
						</span>
						<span v-if="item.messageType == 'RC:CombineMsg'">不支持转发消息</span>
						<!-- 视频消息 -->
						<spider-window-video v-if="item.messageType == 'RC:SightMsg'" :content="item.content" />
						<span v-if="item.messageType == 'RC:RcCmd'">不支持消息</span>
						<span v-if="item.messageType == 'RC:VcMsg'">不支持语音消息</span>
						<span v-if="item.messageType == 'RC:HQVCMsg'">不支持语音消息</span>
						<span v-if="item.messageType == 'RC:LBSMsg'">不支持位置消息</span>
						<!-- 文件消息：优先匹配RC:FileMsg类型，兜底匹配含fileUrl的消息 -->
						<spider-window-file v-if="item.messageType == 'RC:FileMsg'" :content="item.content" />
						<!-- 文件格式兜底：当messageType未被识别但有fileUrl时，也渲染为文件消息 -->
						<spider-window-file v-if="item.messageType != 'RC:FileMsg' && item.content && item.content.fileUrl && !item.content.duration && item.messageType !='RC:ImgMsg' && item.messageType !='RC:StkImgMsg' && item.messageType !='RC:ArticleMsg'" :content="item.content" />
						<!-- 文章格式 -->
						<div v-if="item.messageType == 'RC:ArticleMsg'" class="message-circle-box"
							@click="lookArticleDetail(item)">
							<img :src="item.content.imgUrl" alt="" class="message-circle-box-img" />
							<div class="article-title">{{ item.content.title }}</div>
						</div>
						<!-- 音频格式 -->
						<!-- <audio
						:src="item.content.fileUrl"
						width="300px"
						height="200px"
						controls
						v-if="item.content.fileUrl && item.content.duration"
						/>
						<audio
						:src="item.content.remoteUrl"
						width="300px"
						height="200px"
						controls
						v-if="item.content.remoteUrl && item.content.duration"
						/> -->
						<!-- 位置地图格式 -->
						<!-- <div v-if="item.content.latitude">
						<el-amap
							:center="
							centerMarket(item.content.latitude, item.content.longitude)
							"
							:zoom="zoom"
							:vid="'container' + index"
							:id="'container' + index"
							class="map-container"
						>
							<el-amap-marker
							:position="
								centerMarket(item.content.latitude, item.content.longitude)
							"
							:label="{ content: item.content.poi, offset: [10, 12] }"
							></el-amap-marker>
						</el-amap>
						</div> -->
						<!-- 蜘信卡片格式 -->
						<!-- <div class="spider-message-box-all" v-if="item.content.userId">
						<div class="spider-message-box">
							<img
							:src="item.content.avatar"
							alt=""
							class="spider-message-img"
							/>
							<div>
							<div class="article-title">{{ item.content.name }}</div>
							</div>
						</div>
						<div class="spider-message-text">蜘信卡片</div>
						</div> -->
						<!-- 文件格式 -->
					<spider-window-file v-if="item.content.fileUrl && !item.content.duration && item.messageType !='RC:RecordSpeechMsg' && item.messageType != 'RC:FileMsg'"
						:content="item.content" />
					<!-- 未知消息类型兜底：尝试提取文本内容 -->
					<span v-if="!isKnownMessageType(item)" style="color: #999;">{{ extractFallbackText(item) || '[不支持此类型消息]' }}</span>
				</div>
				<img :src="item.avatar" v-if="item.avatar" class="avatarImg" />
				<img src="@/assets/images/logo@3x.png" v-else class="avatarImg" />
			</template>
			</div>
		</div>
		<el-dialog :title="articleObj.title" :visible.sync="articleVisble" width="800px" :before-close="articleClose">
			<div class="articleContent" v-html="articleObj.content"></div>
			<div class="articleBottom">
				<el-button type="primary" @click="articleClose">关闭</el-button>
			</div>
		</el-dialog>
		<!-- 图片预览弹窗 -->
		<el-dialog :title="'图片预览'" :visible.sync="imagePreviewVisible" width="45%" top="5vh" :before-close="handleImageClose">
			<div class="image-preview-container">
				<img :src="currentImageUrl" alt="预览图片" class="preview-image" />
			</div>
			<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="handleImageClose">关闭</el-button>
				<el-button type="primary" @click="downloadImage">下载图片</el-button>
			</span> -->
		</el-dialog>
	</div>
</template>
<script>
import spiderWindowFile from "./spider-window-file.vue";
import spiderWindowVideo from "./spider-window-video.vue";
import SpiderWindowTime from "./spider-window-time.vue";
import {
	mapState
} from "vuex";

export default {
	components: {
		spiderWindowFile,
		spiderWindowVideo,
		SpiderWindowTime
	},
	props: {
		message: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			articleObj: {}, //文章弹窗对象
			articleVisble: false, //文章弹窗显示和隐藏
			time: null, //时间
			messageAll: [], //聊天的数组
			historyList: [], //历史消息数组
			targetInfo: {}, //目标信息
			userInfo: {}, //用户信息
			center: [118.187551, 24.487623],
			zoom: 30,
			firstStatus: true,
			memberAvatarCache: {}, // 群成员头像缓存
			imagePreviewVisible: false, // 图片预览弹窗显示状态
			currentImageUrl: '', // 当前预览的图片URL

		};
	},
	watch: {
		//发送的信息
		message(newVal, oldVal) {
			this.setTime();
			oldVal = newVal;
			// 保留本地发送的消息（localMessage为true的消息）
			const localMessages = this.messageAll.filter(msg => msg.localMessage);
			// 合并历史消息、新消息和本地发送的消息
			this.messageAll = this.historyList.concat(newVal, localMessages);
			this.$nextTick(() => {
				this.$emit("scrpllEnd");
			});
		},
		//监听收发消息
		updateList(newVal, oldVal) {
			// this.messageAll = [];
			// this.getHistoryMsg(this.targetInfo, this.userInfo);
		},
		// 增加消息列表监听
		messageAll: {
			handler() {
				this.$nextTick(() => {
					this.$emit("scrpllEnd");
				});
			},
			deep: true
		},
		// 监听接收的消息数组（用于私信）
		sendMsgArr: {
			handler(newVal, oldVal) {
				console.log('sendMsgArr 变化:', newVal);
				console.log('当前聊天对象:', this.targetInfo.targetId || this.targetInfo.id);
				
				// 检查是否有新的私信消息
				if (newVal && newVal.length > 0) {
					// 获取最后一条消息
					const lastMsg = newVal[newVal.length - 1];
					console.log('最后一条消息:', lastMsg);
					
					// 检查消息是否来自当前聊天对象
					const currentTargetId = this.targetInfo.targetId || this.targetInfo.id;
					if (lastMsg.targetId === currentTargetId && lastMsg.conversationType === 1) {
						// 检查消息内容是否为空
						let hasContent = false;
						if (lastMsg.content && (lastMsg.content.content || lastMsg.content.imageUri || lastMsg.content.fileUrl)) {
							hasContent = true;
						}
						
						if (hasContent) {
							console.log('消息来自当前聊天对象且有内容，处理并显示');
							
							// 处理消息，添加必要的字段
							const processedMessage = {
								...lastMsg,
								messageDirection: 2, // 2表示接收的消息
								avatar: this.targetInfo.avatar || '', // 使用目标对象的头像
								senderUser: this.targetInfo.nickName || '', // 使用目标对象的昵称
							};
							
							// 添加消息到聊天窗口
							this.addSendMsg(processedMessage);
							
							// 立即强制更新视图
							this.$forceUpdate();
							console.log('消息已添加到聊天窗口，视图已更新');
						} else {
							console.log('消息来自当前聊天对象但内容为空，忽略该消息');
						}
					}
				}
			},
			deep: true
		},
		// 监听消息更新状态（用于触发消息列表刷新）
		msgUpdateStatus(newVal, oldVal) {
			console.log('msgUpdateStatus 变化:', newVal);
			// 可以在这里添加额外的处理逻辑
		}
	},
	computed: {
		...mapState({
			helloss: (contex) => contex.user.helloWord,
			//获取到vuex融云实例化的数据
			RongIMClient: (state) => state.rongyun.RongIMClient,
			updateList: (state) => state.rongyun.updateList, //更新列表
			sendMsgArr: (state) => state.rongyun.sendMsgArr, //接收的消息数组
			msgUpdateStatus: (state) => state.rongyun.msgUpdateStatus, //触发消息列表更新
		}),
	},
	mounted() {
		console.log('spiderWindowMymessage组件已挂载');
		// 注意：group-message-in-chat事件由父组件spider-window-messagebox监听并转发
		// 这里不再重复监听，避免消息重复处理
	},
	beforeDestroy() {
		console.log('spiderWindowMymessage组件即将销毁');
	},
	methods: {
		// 判断消息类型是否已知（模板中有对应的渲染逻辑）
		isKnownMessageType(item) {
			const knownTypes = [
				'ST:GrpNtf', 'RC:TxtMsg', 'RC:ImgMsg', 'RC:GiftMsg',
				'RC:TransferMsg', 'redBagExpire', 'receiveRedPack', 'RC:HeXiRedPackMsg',
				'RC:StkImgMsg', 'RC:CardMsg', 'RC:InvitationMsg', 'RC:GroupInviteMsg',
				'RC:RecordSpeechMsg', 'RC:VideoSpeechMsg', 'RC:SpiderDramaMsg',
				'RC:SpiderNewsMsg', 'RC:SpiderShadowMsg', 'RC:SCCardMsg',
				'RC:CombineMsg', 'RC:SightMsg', 'RC:RcCmd', 'RC:VcMsg', 'RC:HQVCMsg',
				'RC:LBSMsg', 'RC:FileMsg', 'RC:ArticleMsg', 'RC:InfoNtf', 'RC:SRSMsg'
			];
			return knownTypes.includes(item.messageType);
		},
		// 从未知消息类型中提取文本内容
		extractFallbackText(item) {
			if (!item || !item.content) return '';
			let content = item.content;
			// 如果 content 是字符串，尝试解析
			if (typeof content === 'string') {
				try {
					content = JSON.parse(content);
				} catch(e) {
					return content;
				}
			}
			if (!content || typeof content !== 'object') return '';
			// 按优先级检查常见文本字段
			const textFields = ['message', 'content', 'data', 'notification', 'text', 'extra', 'info', 'notice', 'remark', 'description', 'title'];
			for (const field of textFields) {
				if (content[field] && typeof content[field] === 'string' && content[field].trim()) {
					return content[field];
				}
			}
			// 最终兜底：遍历所有 string 类型字段
			for (const key in content) {
				if (typeof content[key] === 'string' && content[key].length > 2) {
					return content[key];
				}
			}
			return '';
		},
		// 处理群聊中的新消息
		handleGroupMessageInChat(message) {
			// 获取当前用户ID
			const currentUserId = this.userInfo.memberId || JSON.parse(localStorage.getItem('loginMsg')).memberId;
			// 根据senderUserId判断消息方向
			const messageDirection = message.senderUserId.toString() === currentUserId.toString() ? 1 : 2;
			
			// 如果是自己发送的消息，检查是否已经通过sendSuccess添加过
			if (messageDirection === 1) {
				// 检查消息是否已经存在（通过sendSuccess添加的）
				const exists = this.messageAll.some(msg => {
					if (msg.localMessage && msg.sentTime === message.sentTime && msg.senderUserId === message.senderUserId) {
						return true;
					}
					return false;
				});
				if (exists) {
					return; // 已经通过sendSuccess添加，跳过
				}
			}
			
			// 处理消息，添加必要的字段
			const processedMessage = {
				...message,
				messageDirection: messageDirection,
				avatar: '',
				senderUser: ''
			};
			
			// 处理头像
			const senderUserId = message.senderUserId;
			if (senderUserId) {
				const cachedMember = this.memberAvatarCache[senderUserId];
				if (cachedMember) {
					processedMessage.avatar = cachedMember.avatar;
					processedMessage.senderUser = cachedMember.nickName;
				} else {
					this.fetchUserInfo(senderUserId, processedMessage);
				}
			}
			
			// 使用addSendMsg方法添加消息，确保去重
			this.addSendMsg(processedMessage);
		},
		// 查看文章详情
		lookArticleDetail(val) {
			this.$api.article.articleDetail(val.content.articleId).then((res) => {
				console.log("文章详情", res.result);
				this.articleObj = res.result
				this.articleVisble = true
			});
		},
		//关闭文章弹窗
		articleClose() {
			this.articleVisble = false
			this.articleObj = {}
		},
		// 点击喇叭图标, 开始播放音频
		handlePlayAudio() {
			// console.log(111)
			this.$refs.audio.play(); // 这里使用了audio的原生开始播放事件,同样不加on, 并使用ref获取dom
			this.isPlay = true;
		},
		// 音频停止后, 把喇叭置灰
		audioEnd() {
			this.isPlay = false;
		},
		//初始化信息 两个参数 第一个参数是目标用户的信息 第二个参数是本人的信息
		init(targetUser, userInfo) {
			//  console.log("这里初始化",targetUser,userInfo)
			this.$store.commit("setTargetId", targetUser.targetId);
			//获取历史消息 把两个参数都传过去 需要获取完信息后把目标人和本人的一些信息补充进去
			this.getHistoryMsg(targetUser, userInfo);
		},
		//地图标记点 一定要有这步 要不然不显示
		centerMarket(latitude, longitude) {
			return [longitude, latitude];
		},
		//设置时间
		setTime() {
			if (this.message.length > 0) {
				let time = this.message[0].sentTime;
				this.time = this.timeFormat(time);
				// console.log(this.time);
			}
		},
		//改变第一次的状态为true
		changeFirstStatus() {
			this.messageAll = [];
			this.firstStatus = true;
		},
		// 添加发送的消息 让看起来不用每次都要请求一遍
		addSendMsg(val) {
			// 检查消息是否有效
			if (!val || !val.content) {
				console.log('addSendMsg: 无效消息，跳过添加');
				return;
			}
			
			// 检查消息内容是否为空
			// 支持多种消息类型：文本消息(content)、图片消息(imageUri)、大表情消息(stickerId/packageUrl)、文件消息(fileUrl/name)、其他消息(extra)
			const contentText = val.content.content || val.content.imageUri || val.content.stickerId || val.content.packageUrl || val.content.fileUrl || val.content.sightUrl || val.content.name || val.content.extra || val.content.message;
			if (!contentText) {
				console.log('addSendMsg: 消息内容为空，跳过添加');
				console.log('addSendMsg: 消息类型:', val.messageType);
				console.log('addSendMsg: 消息内容:', val.content);
				return;
			}
			
			// 生成消息唯一标识：使用 sentTime + senderUserId + content 的组合
			const msgContentKey = val.content?.content || val.content?.imageUri || val.content?.stickerId || val.content?.packageUrl || val.content?.fileUrl || val.content?.name || val.content?.extra || '';
			const msgUniqueKey = `${val.sentTime}_${val.senderUserId}_${msgContentKey}`;
			
			// 检查消息是否已经存在，避免重复添加
			const exists = this.messageAll.some(msg => {
				const existingContentKey = msg.content?.content || msg.content?.imageUri || msg.content?.stickerId || msg.content?.packageUrl || msg.content?.fileUrl || msg.content?.name || msg.content?.extra || '';
				const existingKey = `${msg.sentTime}_${msg.senderUserId}_${existingContentKey}`;
				return existingKey === msgUniqueKey;
			});
			
			if (!exists) {
				// 消息不存在，添加到数组末尾
				this.messageAll.push(val);
				// 立即强制更新视图
				this.$forceUpdate();
				// 滚动到底部
				this.$nextTick(() => {
					this.$emit("scrpllEnd");
				});
			}
		},

		// 获取群成员缓存键
		getGroupCacheKey() {
			const groupId = this.targetInfo.id || this.targetInfo.targetId;
			return `group_members_${groupId}`;
		},

		// 从本地存储加载群成员缓存
		loadGroupMembersFromCache() {
			try {
				const cacheKey = this.getGroupCacheKey();
				const cached = localStorage.getItem(cacheKey);
				if (cached) {
					const parsed = JSON.parse(cached);
					// 检查缓存是否过期（24小时）
					if (Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000) {
						this.memberAvatarCache = parsed.data;
						console.log('从缓存加载群成员头像', this.memberAvatarCache);
						return true;
					}
				}
				return false;
			} catch (error) {
				console.error('加载群成员缓存失败:', error);
				return false;
			}
		},

		// 保存群成员到本地存储
		saveGroupMembersToCache() {
			try {
				const cacheKey = this.getGroupCacheKey();
				const cacheData = {
					data: this.memberAvatarCache,
					timestamp: Date.now()
				};
				localStorage.setItem(cacheKey, JSON.stringify(cacheData));
			} catch (error) {
				console.error('保存群成员缓存失败:', error);
			}
		},

		// 预加载群成员头像
		async preloadGroupMembers() {
			if (this.targetInfo.from !== "group") return;

			// 先尝试从缓存加载
			if (this.loadGroupMembersFromCache()) {
				return;
			}

			try {
				const groupId = this.targetInfo.id || this.targetInfo.targetId;
				if (!groupId) {
					console.error('无法获取群组ID');
					return;
				}
				const response = await this.$api.group.queryMemberListById(groupId);
				if (response.result && response.result.length > 0) {
					response.result.forEach(member => {
						this.memberAvatarCache[member.memberId] = {
							avatar: member.avatar,
							nickName: member.nickName
						};
					});
					console.log('群成员头像预加载完成', this.memberAvatarCache);
					// 保存到本地缓存
					this.saveGroupMembersToCache();
				}
			} catch (error) {
				console.error('预加载群成员头像失败:', error);
			}
		},

		// 获取历史消息
		async getHistoryMsg(targetInfo, userInfo) {
			if (!this.firstStatus) {
				return;
			}
			this.firstStatus = false;
			this.targetInfo = targetInfo;
			this.userInfo = userInfo;
			this.historyList = [];

			// 预加载群成员头像
			await this.preloadGroupMembers();

			var conversation = this.RongIMClient.Conversation.get({
				targetId: targetInfo.from == "group" ? targetInfo.id : targetInfo.memberId,
				type: targetInfo.from == "person" ?
					RongIMLib.CONVERSATION_TYPE.PRIVATE : RongIMLib.CONVERSATION_TYPE.GROUP,
			});
			var option = {
				timestamp: +new Date(),
				count: 20,
			};
			
			try {
				const result = await conversation.getMessages(option);
				var list = JSON.parse(JSON.stringify(result.list)); // 历史消息列表
				var hasMore = result.hasMore; // 是否还有历史消息可以获取
				console.log("消息列表list", list);
				console.log("消息列表长度:", list.length);
				if (list.length > 0) {
					console.log("第一条消息时间:", list[0].sentTime);
					console.log("最后一条消息时间:", list[list.length - 1].sentTime);
				}
				
				// 融云返回的历史消息可能是按时间倒序排列的（最新的在前面）
				// 需要检查并反转数组，使最早的消息在前面
				if (list.length >= 2 && list[0].sentTime > list[list.length - 1].sentTime) {
					console.log("历史消息是倒序，需要反转");
					list.reverse();
				}
				
				// 添加头像 messageDirection 1发送 2接收
				const processedList = await this.processMessageAvatars(list, userInfo, targetInfo);
				
				//合并历史消息和传来的信息列表
				this.messageAll = processedList.concat(this.messageAll);
				console.log("消息列表", this.messageAll);
				
				//保存一下请求的聊天记录 因为 收发消息都要合并这个历史消息数组
				this.historyList = JSON.parse(JSON.stringify(processedList));
				this.$emit("scrpllEnd");
			} catch (err) {
				this.$ryError(err.code);
			}
		},

		// 处理消息头像
		async processMessageAvatars(list, userInfo, targetInfo) {
			const processedList = [...list];
			
			// 收集所有需要获取头像的用户ID（去重）
			const userIdsToFetch = new Set();
			const userIdToMessagesMap = new Map();
			
			processedList.forEach((item) => {
				if (item.messageDirection == 1) {
					// 自己发送的消息
					this.$set(item, "avatar", userInfo.avatar);
					this.$set(item, "senderUser", userInfo.nickName);
				} else if (item.messageDirection == 2) {
					// 接收的消息
					if (this.targetInfo.from == "person") {
						// 私聊
						this.$set(item, "avatar", targetInfo.avatar);
						this.$set(item, "senderUser", targetInfo.nickName);
					} else {
						// 群聊
						const userId = item.senderUserId;
						
						// 优先使用缓存
						const cachedMember = this.memberAvatarCache[userId];
						if (cachedMember) {
							this.$set(item, "avatar", cachedMember.avatar);
							this.$set(item, "senderUser", cachedMember.nickName);
						} else {
							// 收集需要获取的用户ID
							userIdsToFetch.add(userId);
							
							// 建立用户ID到消息的映射（一个用户可能有多条消息）
							if (!userIdToMessagesMap.has(userId)) {
								userIdToMessagesMap.set(userId, []);
							}
							userIdToMessagesMap.get(userId).push(item);
							
							// 先设置默认头像
							this.$set(item, "avatar", '');
							this.$set(item, "senderUser", '未知用户');
						}
					}
				}
			});
			
			// 批量获取头像
			if (userIdsToFetch.size > 0) {
				const fetchPromises = Array.from(userIdsToFetch).map(async (userId) => {
					try {
						const response = await this.$api.member.memberInfoById(userId);
						if (response.result) {
							const { avatar, nickName } = response.result;
							const memberInfo = {
								avatar: avatar || '',
								nickName: nickName || '未知用户'
							};
							
							// 添加到缓存
							this.memberAvatarCache[userId] = memberInfo;
							
							// 更新所有相关消息的头像
							const messages = userIdToMessagesMap.get(userId) || [];
							messages.forEach(msg => {
								this.$set(msg, "avatar", memberInfo.avatar);
								this.$set(msg, "senderUser", memberInfo.nickName);
							});
							
							return memberInfo;
						}
					} catch (error) {
						console.error(`获取用户${userId}信息失败:`, error);
						
						// 设置错误状态的缓存
						const errorMemberInfo = {
							avatar: '',
							nickName: '未知用户'
						};
						this.memberAvatarCache[userId] = errorMemberInfo;
						
						// 更新所有相关消息为默认头像
						const messages = userIdToMessagesMap.get(userId) || [];
						messages.forEach(msg => {
							this.$set(msg, "avatar", errorMemberInfo.avatar);
							this.$set(msg, "senderUser", errorMemberInfo.nickName);
						});
					}
				});
				
				// 等待所有头像获取完成
				await Promise.all(fetchPromises);
				
				// 更新本地存储
				this.saveGroupMembersToCache();
			}
			
			return processedList;
		
		},
		// 处理群成员头像获取
		async handleGroupMemberAvatar(item) {
			// 1. 优先使用缓存
			const cachedMember = this.memberAvatarCache[item.senderUserId];
			if (cachedMember) {
				this.$set(item, "avatar", cachedMember.avatar);
				this.$set(item, "senderUser", cachedMember.nickName);
				return;
			}

			// 2. 缓存中没有，异步获取
			try {
				const response = await this.$api.member.memberInfoById(item.senderUserId);
				if (response.result) {
					const { avatar, nickName } = response.result;
					
					// 设置头像
					this.$set(item, "avatar", avatar || '');
					this.$set(item, "senderUser", nickName || '未知用户');
					
					// 添加到缓存
					this.memberAvatarCache[item.senderUserId] = {
						avatar: avatar || '',
						nickName: nickName || '未知用户'
					};
					
					// 更新本地存储
					this.saveGroupMembersToCache();
				}
			} catch (error) {
				console.error(`获取用户${item.senderUserId}信息失败:`, error);
				// 使用默认头像
				this.$set(item, "avatar", '');
				this.$set(item, "senderUser", '未知用户');
			}
		},

		// 批量获取头像
		async fetchMemberAvatarIfNeeded(userId) {
			if (!this.memberAvatarCache[userId]) {
				return this.$api.member.memberInfoById(userId)
					.then(response => {
						if (response.result) {
							this.memberAvatarCache[userId] = {
								avatar: response.result.avatar || '',
								nickName: response.result.nickName || '未知用户'
							};
						}
					})
					.catch(error => {
						console.error(`批量获取用户${userId}头像失败:`, error);
						this.memberAvatarCache[userId] = {
							avatar: '',
							nickName: '未知用户'
						};
					});
			}
			return null;
		},
		// 初始化地图
		initMap(id, latitude, longitude) {
			if (id) {
				console.log(id, latitude, longitude);
				setTimeout(() => {
					var map = new AMap.Map(id, {
						center: new AMap.LngLat(longitude, latitude),
						zoomEnable: true, //是否禁止缩放
						zoom: 12, //缩放比例
						dragEnable: false, //禁止拖动
						cursor: "hand", // 鼠标在地图上的表现形式，小手
						label: {
							content: "1111",
							offset: [10, 12]
						}, //地图上显示的文字
					});
					// 初始化工具条
					map.plugin(["AMap.ToolBar"], function () {
						map.addControl(new AMap.ToolBar());
					});
					console.log(1);
				}, 500);
			}
		},
		//日期格式化 x月x日 xx:xx
		timeFormat(val) {
			let date = new Date(val);
			let month = date.getMonth() + 1;
			let day = date.getDate();
			let hour = date.getHours();
			let minute = date.getMinutes();
			month = month > 9 ? month : "0" + month;
			day = day > 9 ? day : "0" + day;
			hour = hour > 9 ? hour : "0" + hour;
			minute = minute > 9 ? minute : "0" + minute;
			return month + "月" + day + "日" + " " + hour + ":" + minute;
		},
		// 设置图片的大小
		imgStyle(val, index) {
			var img = document.createElement("img");
			img.src = val.content.imageUri;
			console.log(img.naturalWidth, img.naturalHeight);
			this.messageAll[index].content.width = img.naturalWidth / 4 + "px";
			this.messageAll[index].content.height = img.naturalHeight / 4 + "px";
			this.$forceUpdate();
			// img.onload = () => {
			//   // 为什么要写 onload  是因为要等他加载完之后才能获取到图片宽高
			//   // resolve(img.naturalWidth, img.naturalHeight);   //  2064,4608
			// };
		},
		handleImageLoad(event, item) {
			// 动态设置图片容器尺寸
			const img = event.target;
			const container = img.parentElement;

			const naturalWidth = img.naturalWidth;
			const naturalHeight = img.naturalHeight;
			const aspectRatio = naturalWidth / naturalHeight;
			
			// 设置最大尺寸限制，根据屏幕尺寸动态调整
			const maxWidth = Math.min(300, window.innerWidth * 0.4); // 最大宽度不超过屏幕宽度的40%
			const maxHeight = Math.min(400, window.innerHeight * 0.5); // 最大高度不超过屏幕高度的50%
			
			let displayWidth, displayHeight;
			
			if (aspectRatio > 1) {
				// 横图 - 保持原始比例
				displayWidth = Math.min(maxWidth, naturalWidth);
				displayHeight = displayWidth / aspectRatio;
				// 确保高度不会超过最大高度
				displayHeight = Math.min(displayHeight, maxHeight);
				displayWidth = displayHeight * aspectRatio;
			} else {
				// 竖图 - 保持原始比例
				displayHeight = Math.min(maxHeight, naturalHeight);
				displayWidth = displayHeight * aspectRatio;
				// 确保宽度不会超过最大宽度
				displayWidth = Math.min(displayWidth, maxWidth);
				displayHeight = displayWidth / aspectRatio;
			}
			
			// 应用计算后的尺寸
			container.style.width = `${displayWidth}px`;
			container.style.height = `${displayHeight}px`;
			img.style.width = '100%';
			img.style.height = '100%';
			img.style.objectFit = 'contain';
			
			// 触发滚动到底部
			this.$nextTick(() => {
				// 触发父组件的滚动事件
				this.$emit('scrpllEnd');
			});
		},
		 // 拖拽图片或者文件
		async handleDragStart(event, imageUrl) {
			try {
				// 微信风格：先尝试使用fetch下载（对于支持CORS的域名）
				const response = await fetch(imageUrl, { 
				mode: 'no-cors', // 关键：不检查CORS
				cache: 'force-cache' 
				});
				
				// 如果下载成功，创建blob
				if (response.ok) {
				const blob = await response.blob();
				const blobUrl = URL.createObjectURL(blob);
				
				// 设置拖拽数据
				event.dataTransfer.setData('DownloadURL', `image/jpeg:image_${Date.now()}.jpg:${blobUrl}`);
				
				// 创建预览图
				const img = new Image();
				img.src = blobUrl;
				event.dataTransfer.setDragImage(img, 0, 0);
				
				// 清理
				setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
				}
			} catch (error) {
				// 微信的降级方案：直接打开图片让用户右键保存
				console.log('下载失败，使用微信方案');
				this.useWeChatStyle(imageUrl, event);
			}
		},

		// 微信风格的右键菜单方案
		useWeChatStyle(imageUrl, event) {
			// 阻止默认拖拽
			event.preventDefault();
			
			// 创建微信风格的右键菜单
			const menu = document.createElement('div');
			menu.innerHTML = `
				<div style="
				position: fixed;
				top: ${event.clientY}px;
				left: ${event.clientX}px;
				background: #2c2c2c;
				color: white;
				border-radius: 4px;
				padding: 8px 0;
				box-shadow: 0 2px 8px rgba(0,0,0,0.3);
				z-index: 10000;
				font-size: 14px;
				min-width: 120px;
				">
				<div onclick="window.downloadImage('${imageUrl}')" style="padding: 8px 16px; cursor: pointer; hover:background:#444;">
					保存图片
				</div>
				<div onclick="window.openImage('${imageUrl}')" style="padding: 8px 16px; cursor: pointer; hover:background:#444;">
					查看原图
				</div>
				</div>
			`;
			
			document.body.appendChild(menu);
			
			// 点击其他地方关闭
			setTimeout(() => {
				document.addEventListener('click', () => {
				if (menu.parentNode) menu.remove();
				}, { once: true });
			}, 0);
		},

		// 微信风格的下载方法
		downloadImage(imageUrl) {
			// 创建隐藏的iframe来触发下载（微信风格）
			const iframe = document.createElement('iframe');
			iframe.style.display = 'none';
			iframe.src = imageUrl;
			document.body.appendChild(iframe);
			
			// 或者使用a标签下载
			const link = document.createElement('a');
			link.href = imageUrl;
			link.download = '';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},

		// 点击图片查看大图
		handleImageClick(imageUrl) {
			this.currentImageUrl = imageUrl;
			this.imagePreviewVisible = true;
		},
		
		// 关闭图片预览
		handleImageClose() {
			this.imagePreviewVisible = false;
			this.currentImageUrl = '';
		},
		
		// 下载图片
		downloadImage() {
			if (!this.currentImageUrl) return;
			
			const link = document.createElement('a');
			link.href = this.currentImageUrl;
			link.download = `image_${Date.now()}.jpg`;
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		
		// 获取用户信息并更新头像
		fetchUserInfo(senderUserId, processedMessage) {
			console.log('获取用户信息:', senderUserId);
			this.$api.member.memberInfoById(senderUserId)
				.then(response => {
					if (response.result) {
						const { avatar, nickName } = response.result;
						const memberInfo = {
							avatar: avatar || '',
							nickName: nickName || '未知用户'
						};
						
						// 添加到缓存
						this.memberAvatarCache[senderUserId] = memberInfo;
						
						// 更新消息的头像和用户名
						this.$set(processedMessage, 'avatar', memberInfo.avatar);
						this.$set(processedMessage, 'senderUser', memberInfo.nickName);
						console.log('获取用户信息成功:', memberInfo.nickName);
						
						// 保存到本地存储
						this.saveGroupMembersToCache();
						
						// 强制更新视图
						this.$forceUpdate();
					}
				})
				.catch(error => {
					console.error(`获取用户${senderUserId}信息失败:`, error);
					// 设置默认头像
					const errorMemberInfo = {
						avatar: '',
						nickName: '未知用户'
					};
					this.memberAvatarCache[senderUserId] = errorMemberInfo;
					
					// 更新消息为默认头像
					this.$set(processedMessage, 'avatar', errorMemberInfo.avatar);
					this.$set(processedMessage, 'senderUser', errorMemberInfo.nickName);
					
					// 强制更新视图
					this.$forceUpdate();
				});
		},
	},
};
</script>

<style scoped>
.my-message {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	position: relative;
	width: 100%;
}

.my-chat-info {
	display: flex;
	width: 100%;
	margin-bottom: 20px;
}

.empty {
	width: 42px;
	height: 42px;
	margin-left: 8px;
	border-radius: 50%;
	background: #fff;
}

.notice-message {
	display: none;
	align-self: center;
	flex-direction: row;
	justify-content: center;
	padding: 5px 10px;
	font-size: 12px;
	color: #999;
	background: white;
	border-radius: 50px;
}

.my-chat-info .my-chat {
	word-break: break-all;
	display: inline-block;
	padding: 12px;
	font-size: 16px;
	color: #313233;
	background: #ffffff;
	position: relative;
	border-radius: 5px;
	max-width: 50%;
	margin-right: 8px;
	margin-left: auto;
}

.my-chat-info .my-chat::before {
	position: absolute;
	right: -8px;
	top: 8px;
	content: "";
	border-left: 10px solid #ffffff;
	border-top: 8px solid transparent;
	border-bottom: 8px solid transparent;
}

.friend-message {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	margin-bottom: 20px;
	width: 100%;
}

.friend-message .chat-content {
	word-break: break-all;
	display: inline-block;
	font-size: 16px;
	color: #313233;
	background: #ffffff;
	position: relative;
	border-radius: 5px;
	margin-left: 8px;
	margin-right: auto;
	padding: 12px;
	max-width: 50%;
}

.pad {
	padding: 12px;
	box-sizing: border-box;
}

.friend-message .chat-content::before {
	position: absolute;
	left: -8px;
	top: 8px;
	content: "";
	border-right: 10px solid #ffffff;
	border-top: 8px solid transparent;
	border-bottom: 8px solid transparent;
}

.avatarImg {
	width: 42px;
	height: 42px;
	margin-right: 8px;
	border-radius: 50%;
}

.message-circle-box {
	width: 180px;
	height: 50px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.message-circle-box>.message-circle-box-img {
	flex-shrink: 0;
	width: 50px;
	height: 50px;
}

.article-title {
	font-size: 14px;
	color: #313233;
	margin-left: 8px;
}

.spider-message-box {
	width: 180px;
	height: 50px;
	border-radius: 10px;
	display: flex;
	align-items: center;
}

.spider-message-box>.spider-message-img {
	flex-shrink: 0;
	width: 50px;
	height: 50px;
}

.spider-message-text {
	margin-top: 10px;
	font-size: 10px;
	color: #313233;
	margin-left: 8px;
	width: 100%;
	margin-left: -2px;
	border-top: 1px solid #cccccc;
	padding-top: 5px;
}

.map-container {
	width: 300px;
	height: 180px;
}

.articleBottom {
	width: 100%;
	display: flex;
	justify-content: center;
	margin-top: 30px;
}

.articleContent {
	width: 100%;
	height: 500px;
	overflow-y: scroll;
}

.msgImg {
	max-width: 100%;
	max-height: 100%;
	margin-right: 8px;
	border-radius: 5px;
	display: inline-block;
}

.msgImg {
		max-width: 100%;
		max-height: 400px;
		/* 最大高度限制，适应长图 */
		width: auto;
		height: auto;
		display: block;
		margin-right: 8px;
		border-radius: 5px;
		object-fit: contain;
		/* 保持图片比例 */
	}

	/* 调整消息容器样式 */
	.friend-message .chat-content,
	.my-chat-info .my-chat {
		max-width: 50%;
		min-width: auto;
		padding: 12px;
		overflow: visible;
	}
	.friend-message .chat-content.img-content,.my-chat-info .my-chat.img-content {
	    background: none!important;

	}
 
	/* 专门针对表情包消息的样式 */
	img[class='msgImg'][v-if*="RC:StkImgMsg"] {
		max-width: 120px;
		max-height: 120px;
		display: inline-block;
		/* 保持小表情原有布局 */
	}

	.image-container {
		max-width: 100%;
		position: relative;
		line-height: 0;
		/* 消除图片底部间隙 */
	}

	/* 保留表情图片专用样式 */
	.msgImg[v-if*="RC:ImgMsg"] {
		max-width: 100%;
		max-height: 400px;
		width: auto;
		height: auto;
		display: block;
		object-fit: contain;
	}
	.msgImg {
		max-width: 300px;
		max-height: 400px;
		border-radius: 8px;
		overflow: hidden;
	}

	.msgImg img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	/* 图片预览样式 */
	.image-preview-container {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 400px;
		max-height: 70vh;
		overflow: auto;
	}

	.preview-image {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}

	/* 聊天图片样式优化 */
	.msgImg {
		max-width: 300px;
		max-height: 400px;
		cursor: pointer;
		transition: all 0.3s ease;
		border-radius: 4px;
	}

.msgImg:hover {
	transform: scale(1.02);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 图片内容区域样式 */
.img-content {
	padding: 4px;
	border-radius: 6px;
	background-color: #f5f5f5;
}
</style>